import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'chatManagementExperience.chatGroupList'

const ChatManagementChatGroupListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ChatManagementChatGroupListSlice
